import clsx from 'clsx'
import React from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { IControlledDatePickerRangeProps } from './DatePicker'
import { ControlledHourPicker } from '../hour-picker/ControlledHourPicker'
import DatesCalendar from '../../organisms/dates-calendar/dates-calendar'

export interface DatePickerCalendarFixedProps
  extends Pick<
    IControlledDatePickerRangeProps,
    'isMobile' | 'house' | 'dateCalendarProps' | 'control' | 'nameHours'
  > {
  field: ControllerRenderProps<FieldValues, string>
  onDatesSelected?: (value: boolean) => void
  closeModal?: () => void | null
  shouldDisplayHourPickers: boolean
  revampPicker?: boolean
  onValid?: () => void
}

export const DatePickerCalendarFixed: React.FC<
  DatePickerCalendarFixedProps
> = ({
  isMobile,
  field,
  onDatesSelected,
  closeModal,
  house,
  dateCalendarProps,
  shouldDisplayHourPickers,
  control,
  nameHours,
  revampPicker = false,
  onValid,
}) => {
  return (
    <div
      className={clsx({
        [s.mobileCalendar]: isMobile,
        [s.revampCalendar]: revampPicker,
      })}
    >
      <DatesCalendar
        startDate={field.value?.startDate}
        endDate={field.value?.endDate}
        setDate={({ startDate, endDate }) => {
          field.onChange({
            startDate,
            endDate,
          })
          if (!!startDate && !!endDate) {
            onDatesSelected?.(true)
            onValid?.()
          }
        }}
        closeModal={closeModal}
        house={house}
        activeStartDate={dateCalendarProps.activeStartDate}
        setActiveStartDate={dateCalendarProps.setActiveStartDate}
        shouldDisplayHourPickers={shouldDisplayHourPickers}
        revampPicker={revampPicker}
        houseAvailabilities={dateCalendarProps.houseAvailabilities}
      />

      {shouldDisplayHourPickers ? (
        <div className={s.hourPickers}>
          <ControlledHourPicker
            control={control}
            label="Heure d'arrivée"
            placeholder='18:00'
            name={`${nameHours}.arrivalHour`}
            column={true}
            fullWidth={true}
          />

          <ControlledHourPicker
            control={control}
            label='Heure de départ'
            placeholder='23:00'
            name={`${nameHours}.departureHour`}
            column={true}
            fullWidth={true}
          />
        </div>
      ) : null}
    </div>
  )
}
